var map = {
	"./de.json": [
		1914,
		76
	],
	"./de_CH.json": [
		1915,
		77
	],
	"./de_DE.json": [
		1916,
		78
	],
	"./en.json": [
		673
	],
	"./en_CA.json": [
		1917,
		6
	],
	"./en_CH.json": [
		1872,
		3
	],
	"./en_GB.json": [
		1918,
		7
	],
	"./en_ZA.json": [
		1873,
		3
	],
	"./fr.json": [
		1919,
		79
	],
	"./fr_CA.json": [
		1920,
		2
	],
	"./fr_CH.json": [
		1921,
		2
	],
	"./it.json": [
		1922,
		80
	],
	"./it_CH.json": [
		1923,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 796;
module.exports = webpackAsyncContext;